import { IUtmParams } from "repoV2/interfaces/IUtmParams";
import { getUtmParams } from "repoV2/utils/common/analytics/utmParams";
import {
    IAnalyticsInfo,
    getAnalyticsInfo,
} from "repoV2/utils/common/analytics/analyticsInfo";
import { IGenerateExpressInterestPayload } from "../interfaces/ExpressInterest.interfaces";
import { IPostExpressInterestPayload } from "./api/CreateExpressInterestApi/CreateExpressInterestApi.interfaces";
import { generateExpressInterestUserDetails } from "./generateExpressInterestUserDetails";

/**
 * This utility is used to generate payload for the express interest create api
 * @param data Contains the following values
 - expressInterestFormValues: Form values of the express interest form
 - listingUuid: Uuid id of the listing
 - hostName: host name of the web page.
 * @returns the payload of the express interest create api
 */
export const generateExpressInterestPayload = (
    data: IGenerateExpressInterestPayload
) => {
    const {
        expressInterestFormValues,
        listingUuid,
        dynamicLinkUuid,
        hostName,
        logType,
    } = data;

    const userDetails = generateExpressInterestUserDetails(
        expressInterestFormValues
    );

    // Customer details
    const expressInterestPayload: IPostExpressInterestPayload = {
        ...userDetails,
    };

    // Listing id of the listing
    expressInterestPayload.listing_uuid = listingUuid;

    // Log type to differentiate between express interest and get in touch
    expressInterestPayload.log_type = logType;

    if (dynamicLinkUuid) {
        expressInterestPayload.dynamic_link_id = dynamicLinkUuid;
    }

    // host name of the creator
    expressInterestPayload.sub_domain = hostName;

    // UTM info
    const utm_details: IUtmParams & { referer?: string } = getUtmParams();
    expressInterestPayload.utm_info = utm_details;

    // Analytics info
    const analytics_info: IAnalyticsInfo = getAnalyticsInfo();
    expressInterestPayload.analytics_info = analytics_info;

    return expressInterestPayload;
};
